import * as React from 'react'

import { Separator } from '@thg-commerce/gravity-elements'

import { useProductPage } from '../../context/ProductPageContext'

export const ProductAvailabilityIndicator = () => {
  const { selectedVariant } = useProductPage()

  if (!selectedVariant?.availabilityMessage) {
    return null
  }

  return (
    <React.Fragment>
      <p>{selectedVariant.availabilityMessage}</p>
      <Separator withSpacing />
    </React.Fragment>
  )
}
